import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store/configureStore';
import AuthedHeader from './authedHeader';
import { accountPageList, userPageList } from 'const';

class Header extends Component {

  render() {
    const routes = [];
    let ii;
    for (ii in accountPageList) {
      routes.push(<Route exact key={accountPageList[ii]} path={accountPageList[ii]} component={AuthedHeader} />);
    }
    for (ii in userPageList) {
      routes.push(<Route exact key={userPageList[ii]} path={userPageList[ii]} component={AuthedHeader} />);
    }

    // スタートページ
    routes.push(<Route exact key="start" path="/start" component={AuthedHeader} />);
    return (
      <ConnectedRouter history={history}>
        <Switch>
          {/* 管理者アカウント系画面かユーザー系画面であれば管理者アカウントのヘッダーを表示 */}
          {routes}
        </Switch>
      </ConnectedRouter>
    );
  }
}

export default Header;
